module.exports = __webpack_public_path__ + "static/media/game_cover_archero.888ee72d.png";